import * as axios from 'axios';

function doLogin(formData) {
   
    const data = {
        username: formData.username,
        password: formData.password,
        provider: formData.provider
    };

    const headers = {
        //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Access-Control-Allow-Origin': '*'
    };
  
    const url = `/users/authenticate`;
    return axios.post(url, data, headers)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            return x
        });
}

function accountSetup() {
    const data = {  }
    const headers = {
        //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        'Access-Control-Allow-Origin': '*'
    };

    const url = `/inspect-backend/projects`;
    return axios.get(url, data, headers)
        // get data
        .then(x => x.data)
        // add url field
        .then(x => {
            if (x.status == 'error') {
                return Promise.reject(x);
            }
            return x
        });   
}

export { doLogin, accountSetup }